import * as yup from 'yup'
import { DocumentDto } from './documentDto'
import { ChargeType } from 'enums/Invoicing'

export class VehicleDocumentDto extends DocumentDto {
  vehicleDocumentGuid?: string = undefined
}

export const vehicleDocumentValidationSchema = yup.object({
  documentFile: yup
    .mixed()
    // @ts-ignore
    .test('File is required.', 'File', (value: File) => value)
    .required('File is required.'),
  charge: yup
    .object({
      chargeTypeId: yup.number().min(1, 'Charge Type is required.').required('Charge Type is required.'),
      description: yup.string().max(1_000, 'Description cannot be more than 1,000 characters.').required('Description is required.'),
      amount: yup.number().required('Amount is required.'),
      additionalVINs: yup.array().of(yup.string().min(17, 'Please enter a valid VIN.').max(17, 'Please enter a valid VIN.').required('VIN is required.')),
      amountPerVIN: yup.number().when('chargeTypeId', {
        is: ChargeType.FedEx,
        then: schema => schema.min(0.01, 'Amount Per VIN cannot be less than $0.01.').required('Amount Per VIN is required.'),
        otherwise: schema => schema.nullable()
      })
    })
    .nullable()
})
